import { Capacitor } from '@capacitor/core';

/**
 * Detecta a plataforma atual do dispositivo
 * @returns {string} 'android' | 'ios' | 'navegador'
 */
export const getPlatform = () => {
  if (Capacitor.isNativePlatform()) {
    const platform = Capacitor.getPlatform();
    return platform === 'android' ? 'android' : platform === 'ios' ? 'ios' : 'navegador';
  }
  return 'navegador';
};

/**
 * Verifica se está rodando em um app nativo (Android ou iOS)
 * @returns {boolean}
 */
export const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Verifica se está rodando no Android
 * @returns {boolean}
 */
export const isAndroid = () => {
  return getPlatform() === 'android';
};

/**
 * Verifica se está rodando no iOS
 * @returns {boolean}
 */
export const isIOS = () => {
  return getPlatform() === 'ios';
};

/**
 * Verifica se está rodando no navegador web
 * @returns {boolean}
 */
export const isWeb = () => {
  return getPlatform() === 'navegador';
};

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=br.com.santacasacopacabana.portal&hl=pt_BR';
const APP_STORE_URL = 'https://apps.apple.com/br/app/santa-casa-copacabana/id6754893767';

export const APP_STORE_LINKS = {
  android: {
    url: PLAY_STORE_URL,
    caption: 'DISPONÍVEL NO',
    name: 'Google Play',
    label: 'Disponível no Google Play',
  },
  ios: {
    url: APP_STORE_URL,
    caption: 'Baixar na',
    name: 'App Store',
    label: 'Baixar na App Store',
  },
};

/**
 * Força os selos no navegador de computador.
 * /login?previewApp=1
 * Sem a query, o computador continua sem os selos.
 */
function previewAppStore() {
  if (typeof window === 'undefined') return false;
  const value = new URLSearchParams(window.location.search).get('previewApp');
  return value === 'android' || value === 'ios' || value === '1';
}

/**
 * Mostra os dois selos no navegador de celular.
 * No aplicativo instalado e no computador, não mostra.
 */
export const shouldOfferAppDownload = () => {
  if (typeof navigator === 'undefined' || Capacitor.isNativePlatform()) return false;
  if (previewAppStore()) return true;

  const ua = navigator.userAgent || '';
  const isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return isIpad || /iPhone|iPod/.test(ua) || /Android/i.test(ua);
};

